import CRUDService from './CRUDService';

export interface Extracurricular {
  name: string;
  categories: string[];
}

export default new CRUDService<Extracurricular>('/v1/lists/extracurriculars');
